import React from "react";
import "./style.css";
import { FaGithub, FaTwitter,FaFacebookF, FaLinkedin, FaInstagram } from "react-icons/fa";
import { socialprofils } from "../../content_option";

export default function Socialicons(params) {
  return (
    <div className="stick_follow_icon">
      <ul>
        <li>
          <a href={socialprofils.instagram}>
            <FaInstagram />
          </a>
        </li>
        <li>
          <a href={socialprofils.linkedin}>
            <FaLinkedin />
          </a>
        </li>
      </ul>
      <p></p>
    </div>
  );
}
